  (function(){
    var dataEl = document.getElementById('jb-hero-swap-data');
    if (!dataEl) return;
    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch(e){ return; }
    if (!DATA || !DATA.cities || !DATA.cities.length) return;

    var hero = document.getElementById('joeba-country-hero');
    if (!hero) return;
    var bgWrap = hero.querySelector('.joeba-country-hero__bg');
    var navScroll = document.getElementById('joebaCityNavScroll');
    if (!navScroll) return;

    var landState = null;
    function captureLandState(){
      if (landState) return;
      var backdrop = hero.querySelector('.joeba-country-hero__text-backdrop');
      if (!backdrop) return;
      landState = {
        backdropHTML: backdrop.innerHTML,
        activeBgSrc: (function(){
          var a = bgWrap && bgWrap.querySelector('img.is-active');
          return a ? a.src : null;
        })()
      };
    }
    setTimeout(captureLandState, 600);
    setTimeout(captureLandState, 1500); // vangnet als rich intro langzamer komt

    function swapHeroBg(newSrc){
      if (!bgWrap || !newSrc) return;
      var imgs = bgWrap.querySelectorAll('img');
      var target = null;
      imgs.forEach(function(im){
        if (!im.classList.contains('is-active') && !target) target = im;
      });
      if (!target){
        target = document.createElement('img');
        target.loading = 'lazy';
        target.alt = '';
        bgWrap.appendChild(target);
      }
      target.src = newSrc;
      target.classList.add('jb-kenburns'); // start zoom
      requestAnimationFrame(function(){
        imgs.forEach(function(im){ im.classList.remove('is-active'); });
        target.classList.add('is-active');
        requestAnimationFrame(function(){
          target.classList.remove('jb-kenburns');
        });
      });
    }

    function renderCityBackdrop(city){
      var backdrop = hero.querySelector('.joeba-country-hero__text-backdrop');
      if (!backdrop) return;
      var flag = DATA.countryCode
        ? '<img src="https://flagcdn.com/w80/' + DATA.countryCode + '.png" alt="" class="joeba-country-hero__flag joeba-country-hero__flag--inline" loading="lazy">'
        : '';
      var arts = Array.isArray(city.articles) ? city.articles : [];
      var BASE_THEMES = [
        { id: 'alle',                label: 'Alle',                  emoji: '\u2728', primary: true },
        { id: 'tien-activiteiten',   label: 'Top 10 activiteiten',   emoji: '\ud83c\udfaf' },
        { id: 'dagtrips',            label: 'Dagtrips',              emoji: '\ud83d\ude8c' },
        { id: 'bezienswaardigheden', label: 'Bezienswaardigheden',   emoji: '\ud83c\udfdb\ufe0f' },
        { id: 'natuur-avontuur',     label: 'Natuur & avontuur',     emoji: '\ud83e\udd7e' },
        { id: 'strand-eilanden',     label: 'Strand & eilanden',     emoji: '\ud83c\udfd6\ufe0f' },
        { id: 'rondreizen',          label: 'Rondreizen',            emoji: '\ud83d\ude90' }
      ];
      // Voeg dynamisch elke thema:* uit cats toe (bv. gaudi, flamenco) zodat chip-bar
      // matcht met sidebar/country-rail.
      var THEMES = BASE_THEMES.slice();
      arts.forEach(function(a){
        (a.cats || []).forEach(function(c){
          if (!c) return;
          if (!THEMES.some(function(t){ return t.id === c; })){
            var lbl = c.replace(/-/g,' ').replace(/\b\w/g, function(ch){ return ch.toUpperCase(); });
            THEMES.push({ id: c, label: lbl, emoji: '\ud83c\udff7\ufe0f' });
          }
        });
      });
      var counts = { alle: arts.length };
      arts.forEach(function(a){
        (a.cats || []).forEach(function(c){
          if (!c) return;
          counts[c] = (counts[c] || 0) + 1;
        });
      });
      var availableThemes = THEMES.filter(function(t){ return (counts[t.id] || 0) > 0; });
      var pillsHtml = '<div class="joeba-hero-themes is-ready jb-city-hero-themes" aria-label="Thema\'s in ' + escapeAttr(city.name) + '">' +
        '<div class="joeba-hero-themes__label">Thema\'s in ' + escapeHtml(city.name) + '</div>' +
        '<div class="joeba-hero-themes__chips">' +
          '<button type="button" class="jb-hero-chip is-active" data-cat="alle"><span>\u2728</span>Alles<span class="jb-hero-chip__count">' + arts.length + '</span></button>' +
          availableThemes.filter(function(t){ return t.id !== 'alle'; }).map(function(t){
            return '<button type="button" class="jb-hero-chip" data-cat="' + escapeAttr(t.id) + '"><span>' + t.emoji + '</span>' + escapeHtml(t.label) + '<span class="jb-hero-chip__count">' + (counts[t.id] || 0) + '</span></button>';
          }).join('') +
        '</div>' +
      '</div>';

      // Card-markup IDENTIEK aan country-rail (.jb-mini-card) zodat styling consistent
      // is tussen /blogs/{land} en /blogs/{land}#stad-{handle}.
      var cityLbl = escapeHtml(city.name);
      var cardsHtml = arts.length
        ? '<button type="button" class="jb-hero-rail-arrow jb-hero-rail-arrow--prev" data-jb-hero-rail-dir="prev" aria-label="Vorige">\u2039</button>' +
          '<div class="jb-hero-rail" data-jb-hero-rail>' +
          arts.map(function(a){
            var catsAttr = '|' + (a.cats || []).join('|') + '|';
            var imgInner = a.image
              ? '<img src="' + a.image + '" alt="" loading="lazy" width="520" height="320">'
              : '<div class="jb-mini-card__ph"></div>';
            var firstCat = (a.cats || []).filter(function(c){ return c && c !== 'alle'; })[0] || '';
            var themaLbl = firstCat ? firstCat.replace(/-/g,' ').replace(/^./, function(s){return s.toUpperCase();}) : '';
            var stickerHtml = '<div class="jb-mini-card__eyebrows">' +
              (themaLbl ? '<span class="jb-mini-card__eyebrow jb-mini-card__eyebrow--thema">' + escapeHtml(themaLbl) + '</span>' : '') +
              (a.stickers && a.stickers.length
                ? a.stickers.map(function(s){ return '<span class="jb-mini-card__eyebrow jb-mini-card__eyebrow--sticker">' + escapeHtml(s) + '</span>'; }).join('')
                : (a.sticker ? '<span class="jb-mini-card__eyebrow jb-mini-card__eyebrow--sticker">' + escapeHtml(a.sticker) + '</span>' : '')) +
              '</div>';
            return '<a href="' + a.url + '" class="jb-mini-card" data-city-handle="' + escapeAttr(city.handle) + '" data-jb-themes="' + escapeAttr(catsAttr) + '" data-cats="' + escapeAttr((a.cats||[]).join(' ')) + '">' +
              '<div class="jb-mini-card__media">' + imgInner + stickerHtml + '</div>' +
              '<div class="jb-mini-card__body">' +
                '<h3 class="jb-mini-card__title">' + escapeHtml(a.title) + '</h3>' +
                '<div class="jb-mini-card__meta">' +
                  (a.date ? '<span class="jb-mini-card__pill"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>' + escapeHtml(a.date) + '</span>' : '') +
                  (a.rt ? '<span class="jb-mini-card__pill"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>' + a.rt + ' min</span>' : '') +
                '</div>' +
              '</div>' +
            '</a>';
          }).join('') +
          '</div>' +
          '<button type="button" class="jb-hero-rail-arrow jb-hero-rail-arrow--next" data-jb-hero-rail-dir="next" aria-label="Volgende">\u203a</button>'
        : '<div class="jb-city-mini__empty">Nog geen reisgidsen voor deze stad. Bekijk activiteiten op GetYourGuide.</div>';

      // Quick-actions: alleen Terug (de kaartknop staat al rechtsboven in de hero).
      var qaHtml =
        '<div class="joeba-country-hero__quick-actions" aria-label="Snelle acties">' +
          '<button type="button" class="joeba-country-hero__qa-btn" data-jb-hero-back aria-label="Terug naar ' + escapeAttr(DATA.country) + '">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>' +
            'Terug' +
          '</button>' +
        '</div>';

      var html =
        '<div class="jb-city-hero-top">' +
          flag +
          '<h1 class="joeba-country-hero__title">' + escapeHtml(city.name) + ', ' + escapeHtml(DATA.country) + '</h1>' +
        '</div>' +
        '<div class="jb-meta-row">' +
          '<div class="joeba-country-hero__meta">' +
            '<span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><path d="M8 21h8"/><path d="M12 17v4"/></svg> <strong>' + city.count + '</strong> ' + (city.count === 1 ? 'reisgids' : 'reisgidsen') + '</span>' +
          '</div>' +
        '</div>' +
        '<div class="joeba-country-hero__bloglist">' + cardsHtml + '</div>' +
        pillsHtml;
      backdrop.innerHTML = html;
      mountCornerBack(qaHtml);
      updateSidebarThemes(city, counts, availableThemes, arts.length);

      var pills = backdrop.querySelectorAll('.jb-hero-chip[data-cat]');
      var cards = backdrop.querySelectorAll('.jb-mini-card');
      pills.forEach(function(p){
        p.addEventListener('click', function(){
          var cat = p.getAttribute('data-cat');
          pills.forEach(function(x){ x.classList.toggle('is-active', x === p); });
          cards.forEach(function(c){
            var cats = (c.getAttribute('data-cats') || '').split(' ');
            var show = (cat === 'alle') || cats.indexOf(cat) !== -1;
            c.classList.toggle('jb-mini-hidden', !show);
          });
        });
      });
      // Rail-arrows binden voor de zojuist ingevoegde rail.
      (function(){
        if (typeof window.jbHeroRailRefresh === 'function') {
          window.jbHeroRailRefresh();
          setTimeout(window.jbHeroRailRefresh, 260);
          return;
        }
        var rail = backdrop.querySelector('[data-jb-hero-rail]');
        var wrap = backdrop.querySelector('.joeba-country-hero__bloglist');
        if (!rail || !wrap) return;
        wrap.querySelectorAll('.jb-hero-rail-arrow').forEach(function(b){
          b.addEventListener('click', function(){
            var dir = b.getAttribute('data-jb-hero-rail-dir');
            var step = Math.max(220, rail.clientWidth * 0.85);
            rail.scrollBy({ left: (dir === 'next' ? 1 : -1) * step, behavior: 'smooth' });
          });
        });
      })();
      var heroBack = document.querySelector('.jb-hero-corner [data-jb-hero-back]') || backdrop.querySelector('[data-jb-hero-back]');
      if (heroBack){
        heroBack.addEventListener('click', function(e){
          e.preventDefault();
          swapTo('land');
        });
      }
    }


    // Terug-knop in de cornerrij plaatsen, direct vóór de kaartknop.
    function unmountCornerBack(){
      var old = document.querySelector('.jb-hero-corner [data-jb-hero-back]');
      if (old && old.parentNode) old.parentNode.removeChild(old);
    }
    function mountCornerBack(qaHtml){
      var qa = document.querySelector('.jb-hero-corner .joeba-country-hero__quick-actions');
      if (!qa) return;
      unmountCornerBack();
      var tmp = document.createElement('div');
      tmp.innerHTML = qaHtml;
      var btn = tmp.querySelector('[data-jb-hero-back]');
      if (btn) qa.insertBefore(btn, qa.firstChild);
    }

    function updateSidebarThemes(city, counts, availableThemes, total){
      var list = document.getElementById('jbBlogTocList');
      if (!list) return;
      var html = '<button type="button" class="jb-blog-toc__pill is-active" data-city-cat="alle">Alles<span class="jb-blog-toc__count" style="margin-left:6px;opacity:.7;font-size:.85em">' + total + '</span></button>';
      availableThemes.filter(function(t){ return t.id !== 'alle'; }).forEach(function(t){
        html += '<button type="button" class="jb-blog-toc__pill" data-city-cat="' + escapeAttr(t.id) + '"><span class="jb-blog-toc__emoji">' + t.emoji + '</span>' + escapeHtml(t.label) + '<span class="jb-blog-toc__count" style="margin-left:6px;opacity:.7;font-size:.85em">' + (counts[t.id] || 0) + '</span></button>';
      });
      list.innerHTML = html;
      list.querySelectorAll('[data-city-cat]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var cat = btn.getAttribute('data-city-cat');
          list.querySelectorAll('[data-city-cat]').forEach(function(b){ b.classList.toggle('is-active', b === btn); });
          var heroChip = hero.querySelector('.jb-hero-chip[data-cat="' + cat + '"]');
          if (heroChip) heroChip.click();
        });
      });
      var label = document.querySelector('.jb-blog-toc__label--themes');
      if (label) label.textContent = "Thema's in " + city.name;
    }

    function restoreLandBackdrop(){
      if (!landState) return;
      var backdrop = hero.querySelector('.joeba-country-hero__text-backdrop');
      if (!backdrop) return;
      backdrop.innerHTML = landState.backdropHTML;
      bindLandLibraryControls();
    }

    function bindLandLibraryControls(){
      var rail = document.getElementById('jbLibraryGrid');
      if (rail){
        document.querySelectorAll('[data-jb-hcities-dir]').forEach(function(b){
          if (b.getAttribute('data-jb-hcities-rebound') === '1') return;
          b.setAttribute('data-jb-hcities-rebound','1');
          b.addEventListener('click', function(){
            var d = b.getAttribute('data-jb-hcities-dir');
            var s = Math.max(220, rail.clientWidth * 0.85);
            rail.scrollBy({ left: (d === 'next' ? 1 : -1) * s, behavior: 'smooth' });
          });
        });
      }
      var inp = document.getElementById('jbLibrarySearch'), gr = document.getElementById('jbLibraryGrid'), em = document.getElementById('jbLibraryEmpty');
      if (inp && gr && inp.getAttribute('data-jb-library-search-rebound') !== '1'){
        inp.setAttribute('data-jb-library-search-rebound','1');
        var tiles = Array.prototype.slice.call(gr.querySelectorAll('[data-jb-library-tile]'));
        var norm = function(s){ return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,''); };
        var apply = function(q){
          q = norm(q.trim());
          var visible = 0;
          tiles.forEach(function(t){
            var ok = !q || norm(t.getAttribute('data-city-name') || '').indexOf(q) !== -1;
            t.classList.toggle('is-hidden', !ok);
            if (ok) visible++;
          });
          if (em) em.hidden = visible !== 0;
          document.querySelectorAll('.jb-hero-rail .jb-mini-card').forEach(function(c){
            if (!q){ c.classList.remove('jb-mini-hidden'); return; }
            var titleEl = c.querySelector('.jb-mini-card__title');
            var title = norm(titleEl ? titleEl.textContent : '');
            var city = norm(c.getAttribute('data-city-handle') || '');
            var themes = norm(c.getAttribute('data-jb-themes') || '');
            c.classList.toggle('jb-mini-hidden', !(title.indexOf(q) !== -1 || city.indexOf(q) !== -1 || themes.indexOf(q) !== -1));
          });
          if (typeof window.jbHeroRailRefresh === 'function') window.jbHeroRailRefresh();
        };
        var timer;
        inp.addEventListener('input', function(){
          clearTimeout(timer);
          timer = setTimeout(function(){ apply(inp.value); }, 80);
        });
      }
      document.querySelectorAll('[data-jb-library-tile]').forEach(function(tile){
        if (tile.getAttribute('data-jb-library-rebound') === '1') return;
        tile.setAttribute('data-jb-library-rebound','1');
        tile.addEventListener('click', function(e){
          var h = tile.getAttribute('data-city-handle');
          if (!h) return;
          e.preventDefault();
          swapTo('city', h);
          try { history.replaceState(null, '', location.pathname + location.search + '#stad-' + h); } catch(_) {}
          var bl = document.getElementById('joebaHeroBlogList');
          if (bl) setTimeout(function(){
            var y = bl.getBoundingClientRect().top + window.pageYOffset - 80;
            window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
          }, 220);
        });
      });
      if (typeof window.jbHeroRailRefresh === 'function') setTimeout(window.jbHeroRailRefresh, 80);
    }

    function escapeHtml(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]; }); }
    function escapeAttr(s){ return escapeHtml(s); }

    function swapTo(mode, cityHandle){
      captureLandState();
      var cityObj = null;
      if (mode === 'city') {
        for (var i=0;i<DATA.cities.length;i++){ if (DATA.cities[i].handle === cityHandle){ cityObj = DATA.cities[i]; break; } }
        if (!cityObj) return;
      }
      // Sync gygCityName zodat jb-gyg-row ("Populair in ...") meebeweegt met stad/land.
      try {
        var gygNameEl = document.getElementById('gygCityName');
        if (gygNameEl){
          var newName = (mode === 'city') ? cityObj.name : (DATA.country || gygNameEl.textContent || '');
          if (newName && gygNameEl.textContent !== newName){
            gygNameEl.textContent = newName;
          }
        }
      } catch(_){}
      hero.classList.add('is-swapping-out');
      setTimeout(function(){
        if (mode === 'city'){
          if (cityObj.image) swapHeroBg(cityObj.image);
          renderCityBackdrop(cityObj);
          if (typeof window.jbHeroRailRefresh === 'function') setTimeout(window.jbHeroRailRefresh, 280);
          hero.classList.add('is-city-mode');
          document.body.classList.add('jb-city-mode-active');
          showCitySection(cityObj.handle);
          updateNavActive(cityObj.handle);
          if (history && history.replaceState){
            history.replaceState(null, '', '#stad-' + cityObj.handle);
          }
        } else {
          if (landState && landState.activeBgSrc) swapHeroBg(landState.activeBgSrc);
          restoreLandBackdrop();
          if (typeof window.jbHeroRailRefresh === 'function') setTimeout(window.jbHeroRailRefresh, 280);
          hero.classList.remove('is-city-mode');
          unmountCornerBack();
          document.body.classList.remove('jb-city-mode-active');
          hideAllCitySections();
          updateNavActive(null);
          if (history && history.replaceState){
            history.replaceState(null, '', location.pathname + location.search);
          }
          // Reset sidebar themabar terug naar land-context (alle thema's + "Thema's" label)
          var sidebarLabel = document.querySelector('.jb-blog-toc__label--themes');
          if (sidebarLabel) sidebarLabel.textContent = "Thema's";
          if (typeof window.jbRebuildBlogTocPills === 'function') {
            setTimeout(window.jbRebuildBlogTocPills, 60);
          }
        }
        hero.classList.remove('is-swapping-out');
        hero.classList.add('is-swapping-in');
        requestAnimationFrame(function(){
          requestAnimationFrame(function(){
            hero.classList.remove('is-swapping-in');
          });
        });
      }, 230);
    }

    window.joebaSwapToLand = function(){ swapTo('land'); };
    window.joebaSwapToCity = function(handle){ swapTo('city', handle); };

    function showCitySection(handle){
      var sections = document.querySelectorAll('.joeba-blog-city');
      sections.forEach(function(s){
        if (s.getAttribute('data-city-handle') === handle){ s.classList.add('is-active'); }
        else { s.classList.remove('is-active'); }
      });
    }
    function hideAllCitySections(){
      document.querySelectorAll('.joeba-blog-city.is-active').forEach(function(s){ s.classList.remove('is-active'); });
    }
    function updateNavActive(handle){
      navScroll.querySelectorAll('.joeba-city-nav__link').forEach(function(b){
        if (handle && b.getAttribute('data-nav-city') === handle) b.classList.add('is-active');
        else b.classList.remove('is-active');
      });
      var countryPill = document.querySelector('.joeba-city-nav__link--country[data-nav-country]');
      if (countryPill){
        if (handle) countryPill.classList.add('is-active');
        else countryPill.classList.remove('is-active');
      }
    }


    var navWrapper = navScroll.parentNode || navScroll;
    navWrapper.addEventListener('click', function(e){
      var countryBtn = e.target.closest && e.target.closest('.joeba-city-nav__link--country[data-nav-country]');
      if (countryBtn){
        e.preventDefault();
        e.stopPropagation();
        swapTo('land');
        try {
          if (location.hash) history.replaceState(null, '', location.pathname + location.search);
        } catch(_) {}
        var heroEl = document.querySelector('.joeba-country-hero');
        if (heroEl){
          setTimeout(function(){
            var r = heroEl.getBoundingClientRect();
            var y = r.top + window.pageYOffset - 80;
            window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
          }, 260);
        }
        return;
      }
      var btn = e.target.closest && e.target.closest('.joeba-city-nav__link[data-nav-city]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-nav-city');
      swapTo('city', handle);

      try {
        var newHash = '#stad-' + handle;
        if (location.hash !== newHash) {
          history.replaceState(null, '', location.pathname + location.search + newHash);
        }
      } catch(_) {}

      runHeroScroll();
    }, true); // capture-fase: vóór andere handlers

    function getHeaderOffset(){
      var off = 0;
      var sels = ['.shopify-section-header-sticky', 'sticky-header', '.header-wrapper', '.section-header', '#shopify-section-header'];
      for (var i=0;i<sels.length;i++){
        var el = document.querySelector(sels[i]);
        if (!el) continue;
        var r = el.getBoundingClientRect();
        if (r.height > 0 && r.top <= 5) { off = Math.max(off, r.height); }
        else if (r.height > 0 && off === 0) { off = r.height; }
      }
      var sb = document.querySelector('.has-art-bs, .joeba-blog-spotlight-bar');
      if (sb){ var sr = sb.getBoundingClientRect(); if (sr.height > 0 && sr.top <= off + 5) off += sr.height; }
      return off || 80;
    }
    function doHeroScroll(behavior){
      var activeSection = document.querySelector('.joeba-blog-city.is-active');
      var target = hero.classList.contains('is-city-mode')
        ? hero
        : (activeSection && activeSection.querySelector('.joeba-city-hero')) || activeSection || hero;
      if (!target) return;
      var offset = getHeaderOffset();
      var rect = target.getBoundingClientRect();
      var pageTop = rect.top + window.pageYOffset;
      var pageBottom = rect.bottom + window.pageYOffset;
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var bottomGap = 24, minTopGap = 18;
      var availableHeight = Math.max(0, viewportHeight - offset - bottomGap);
      var topAlignedY = pageTop - offset - minTopGap;
      var bottomAlignedY = pageBottom - viewportHeight + bottomGap;
      var y = topAlignedY;
      if (hero.classList.contains('is-city-mode')) {
        window.scrollTo({ top: Math.max(0, pageTop - offset + 2), behavior: behavior || 'smooth' });
        return;
      }
      if (rect.height > 0 && availableHeight > rect.height + minTopGap) {
        var spare = availableHeight - rect.height;
        var framingGap = Math.max(minTopGap, Math.min(140, Math.round(spare * 0.55)));
        y = pageTop - offset - framingGap;
      }
      if (bottomAlignedY > y) y = bottomAlignedY;
      window.scrollTo({ top: Math.max(0, y), behavior: behavior || 'smooth' });
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      if (target.focus) target.focus({ preventScroll: true });
    }
    function runHeroScroll(){
      requestAnimationFrame(function(){ doHeroScroll('smooth'); });
      setTimeout(function(){ doHeroScroll('smooth'); }, 280);
      setTimeout(function(){ doHeroScroll('smooth'); }, 600);
      setTimeout(function(){ doHeroScroll('smooth'); }, 1100);
      setTimeout(function(){ doHeroScroll('smooth'); }, 1800);
    }
    window.joebaScrollHeroIntoView = runHeroScroll;

    function handleHash(){
      var raw = (location.hash || '').replace(/^#/, '');
      if (!raw) return;
      var handle = raw.indexOf('stad-') === 0 ? raw.substring(5) : raw;
      if (!handle) return;
      var exists = !!document.querySelector('.joeba-blog-city[data-city-handle="' + handle.replace(/"/g,'') + '"]');
      if (!exists) return;
      setTimeout(function(){
        swapTo('city', handle);
        runHeroScroll();
      }, 700);
    }
    window.addEventListener('hashchange', handleHash);
    if (location.hash) {
      try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch(_) {}
      window.scrollTo(0, 0);
      requestAnimationFrame(function(){ window.scrollTo(0, 0); });
      setTimeout(function(){ window.scrollTo(0, 0); }, 120);
      handleHash();
    }
  })();
